module.exports = __webpack_public_path__ + "img/linkedin.6b16561d.svg";